import {
  QueryKeyLocalStorageEnum,
  CardNumberSortEnum,
  OwnerIdSortEnum,
  OwnerPermissionsIdSortEnum,
  OwnerGroupIdSortEnum,
  PositionNameSortEnum,
  EventExportFormatNameSortEnum,
  GroupsIdSortEnum,
  GroupTerminalsPermissionsIdSortEnum,
  EventDateSortEnum,
  TerminalIdSortEnum,
  OwnersQueryKeysEnum,
  EventsQueryKeysEnum,
  InneEventsQueryKeysEnum,
  GlcTerminalsIdSortEnum,
  GroupGlcPermissionsIdSortEnum,
  GlcNumberSortEnum,
  TerminalWithDisplayIdSortEnum,
  InstantControlIdSortEnum,
  InstantControlTerminalsIdSortEnum,
  RandomControlIdSortEnum,
  RandomControlTerminalsIdSortEnum,
  WantedIdSortEnum,
  WantedTerminalsIdSortEnum,
  SchedulesNameSortEnum,
  AnnouncementsNameSortEnum,
  SchedulesExceptionsDateSortEnum,
  SequencesIdSortEnum,
  UsersUsernameSortEnum,
  TerminalWithSequenceIdSortEnum,
  CurrentPresenceOwnersEntryDateSortEnum,
  PassagesIdSortEnum,
} from '../queryContext/QueryContext.enum';
import { QueryState } from '../queryContext/QueryContext.types';

export const DEFAULT_QUERY_STATE: QueryState = {
  [QueryKeyLocalStorageEnum.CARDS]: { sort: [CardNumberSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ARCHIVED_CARDS]: { sort: [CardNumberSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.TERMINALS]: { sort: [TerminalIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ACTIVE_CARD_HISTORY]: {},
  [QueryKeyLocalStorageEnum.ARCHIVED_CARD_HISTORY]: {},
  [QueryKeyLocalStorageEnum.EVENTS_HISTORY]: {
    sort: [EventDateSortEnum.DESC],
    [EventsQueryKeysEnum.DATA_OD]: undefined,
    [EventsQueryKeysEnum.DATA_DO]: undefined,
    [EventsQueryKeysEnum.ZDARZENIE]: undefined,
    [EventsQueryKeysEnum.MOD]: undefined,
    [EventsQueryKeysEnum.TRYB]: undefined,
    [EventsQueryKeysEnum.RCP]: undefined,
    [EventsQueryKeysEnum.SERVER]: undefined,
  },
  [QueryKeyLocalStorageEnum.EVENTS_OTHER]: {
    sort: [EventDateSortEnum.DESC],
    [InneEventsQueryKeysEnum.DATA_OD]: undefined,
    [InneEventsQueryKeysEnum.DATA_DO]: undefined,
    [InneEventsQueryKeysEnum.MOD]: undefined,
    [InneEventsQueryKeysEnum.KATEGORIA]: undefined,
    [InneEventsQueryKeysEnum.SERVER]: undefined,
    [InneEventsQueryKeysEnum.CZYTNIK]: undefined,
  },
  [QueryKeyLocalStorageEnum.OWNERS]: { sort: [OwnerIdSortEnum.ASC], [OwnersQueryKeysEnum.STANOWISKO]: [] },
  [QueryKeyLocalStorageEnum.ARCHIVED_OWNERS]: { sort: [OwnerIdSortEnum.ASC], [OwnersQueryKeysEnum.STANOWISKO]: [] },
  [QueryKeyLocalStorageEnum.ACTIVE_OWNER_HISTORY]: {},
  [QueryKeyLocalStorageEnum.ACTIVE_OWNER_PERMISSIONS_EFFECTIVE]: { sort: [OwnerPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ACTIVE_OWNER_PERMISSIONS_INDIVIDUAL]: { sort: [OwnerPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ACTIVE_OWNER_GROUPS]: { sort: [OwnerGroupIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ARCHIVED_OWNER_HISTORY]: {},
  [QueryKeyLocalStorageEnum.ARCHIVED_OWNER_PERMISSIONS_EFFECTIVE]: { sort: [OwnerPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ARCHIVED_OWNER_PERMISSIONS_INDIVIDUAL]: { sort: [OwnerPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ARCHIVED_OWNER_GROUPS]: { sort: [OwnerGroupIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.POSITIONS]: { sort: [PositionNameSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.EVENTS_EXPORT_FORMAT]: { sort: [EventExportFormatNameSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GROUPS]: { sort: [GroupsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GROUP_HISTORY]: {},
  [QueryKeyLocalStorageEnum.GROUP_PERMISSIONS_HISTORY]: {},
  [QueryKeyLocalStorageEnum.ARCHIVED_GROUPS]: { sort: [GroupsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GROUP_TERMINALS_PERMISSIONS]: { sort: [GroupTerminalsPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GROUP_GLC_PERMISSIONS]: { sort: [GroupGlcPermissionsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GROUP_ASSIGNED_OWNERS]: { sort: [OwnerIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ACTIVE_GLC]: { sort: [GlcNumberSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ARCHIVED_GLC]: { sort: [GlcNumberSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GLC_TERMINALS]: { sort: [GlcTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.GLC_HISTORY]: {},
  [QueryKeyLocalStorageEnum.USERS]: { sort: [UsersUsernameSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SELECTED_SEARCH_OPTIONS]: {},
  [QueryKeyLocalStorageEnum.OWNER_EFFECTIVE_PERMISSIONS_HISTORY]: {},
  [QueryKeyLocalStorageEnum.TERMINALS_WITH_DISPLAY]: { sort: [TerminalWithDisplayIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.TERMINALS_WITH_SEQUENCE]: { sort: [TerminalWithSequenceIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.CONTROL_HISTORY]: {},
  [QueryKeyLocalStorageEnum.INSTANT_CONTROL]: { sort: [InstantControlIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.INSTANT_CONTROL_TERMINALS]: { sort: [InstantControlTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.RANDOM_CONTROL]: { sort: [RandomControlIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.RANDOM_CONTROL_TERMINALS]: { sort: [RandomControlTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.WANTED]: { sort: [WantedIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.WANTED_HISTORY]: {},
  [QueryKeyLocalStorageEnum.WANTED_TERMINALS]: { sort: [WantedTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ANNOUNCEMENTS]: { sort: [AnnouncementsNameSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.ANNOUNCEMENTS_HISTORY]: {},
  [QueryKeyLocalStorageEnum.ANNOUNCEMENT_ASSIGNED_OWNERS]: { sort: [OwnerIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SCHEDULES]: { sort: [SchedulesNameSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SCHEDULES_EXCEPTIONS]: { sort: [SchedulesExceptionsDateSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SCHEDULES_HISTORY]: {},
  [QueryKeyLocalStorageEnum.SCHEDULE_TERMINALS]: { sort: [WantedTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SCHEDULE_EXCEPTION_TERMINALS]: { sort: [WantedTerminalsIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SEQUENCES]: { sort: [SequencesIdSortEnum.ASC] },
  [QueryKeyLocalStorageEnum.SEQUENCES_HISTORY]: {},
  [QueryKeyLocalStorageEnum.USERS_LOGIN_HISTORY]: {},
  [QueryKeyLocalStorageEnum.USER_HISTORY]: {},
  [QueryKeyLocalStorageEnum.USER_PERMISSIONS_HISTORY]: {},
  [QueryKeyLocalStorageEnum.CURRENT_PRESENCE_OWNERS]: { sort: [CurrentPresenceOwnersEntryDateSortEnum.DESC] },
  [QueryKeyLocalStorageEnum.PASSAGES]: { sort: [PassagesIdSortEnum.ASC] },
};
